import { render, staticRenderFns } from "./PoliceCities.vue?vue&type=template&id=905c29ee"
import script from "./PoliceCities.vue?vue&type=script&lang=js"
export * from "./PoliceCities.vue?vue&type=script&lang=js"
import style0 from "./PoliceCities.vue?vue&type=style&index=0&id=905c29ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports